import { baseDevConfig } from "./baseEnv";

export const devConfig = {
  ...baseDevConfig,
  FILE_SUFFIX: "",
  ARCHFORM_DASH_V1_BASE_URL: "https://d2spg4xirn83ur.cloudfront.net",
}